// extracted by mini-css-extract-plugin
export default {"categories_wrapper":"Categories_categories_wrapper__ikUz8","active":"Categories_active__4ygIi"};